import { useQuery } from "@tanstack/react-query";
import { ITToolsService } from "../../../../../services/it-tools-request/itTool.service";
import { useCallback, useMemo } from "react";

export const useITTools = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["it-tools"],
    queryFn: () => ITToolsService.getToolsType(),
  });

  const itToolOptions = useMemo(() => (!data ? [] : data.map((e: any) => ({ label: e.Title, value: e.id }))), [data]);

  const getItTool = useCallback(
    (iTToolSelected: any) =>
      !data ? null : data.find((e: any) => e.id === iTToolSelected.value || e.id === iTToolSelected),
    [data],
  );
  return { data, isLoading, itToolOptions, getItTool };
};
